import React, { useEffect } from 'react';
import { Modal } from '../modal';
import { Flex, Button } from '@mantine/core';
import { ReactComponent as Trash } from './trash.svg';
import { useIntl } from 'react-intl';
import { theme } from '../globalStyle/global-styles';
import { BiSolidErrorAlt } from 'react-icons/bi';
import { DeleteButtonContainer } from './styles';

interface ErrorModalProps {
  showErrorModal: boolean;
  setShowErrorModal: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  navigateTo?: string;
  needsFormat?: boolean;
  showCloseBtn?: boolean;
  onClose?:() => void;
}

export function ErrorModal({
  showErrorModal,
  setShowErrorModal,
  message,
  onClose,
  navigateTo = '',
  needsFormat = true,
  showCloseBtn = false,
}: ErrorModalProps) {
  const { formatMessage } = useIntl();

  return (
    <Modal
      opened={showErrorModal}
      size="xs"
      onClose={() => {
        setShowErrorModal(false);
      }}
      withCloseButton={false}
      padding="36px 15px"
      closeOnEscape={false}
    >
      <Flex justify={'center'} align={'center'} direction={'column'} gap={32}>
        <BiSolidErrorAlt size={100} color={theme.colours.blackText} />
        <p
          style={{
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: `${theme.fonts.Regular}`,
            textAlign: 'center',
          }}
        >
          {needsFormat ? formatMessage({ id: `${message}` }) : message}
        </p>

        <DeleteButtonContainer>
          <Button
            id="okBtn"
            type="reset"
            onClick={() => {
              onClose && onClose()
              setShowErrorModal(false);
            }}
          >
            {formatMessage({ id: 'ok' })}
          </Button>
        </DeleteButtonContainer>
      </Flex>
    </Modal>
  );
}
